import { Radio, Spin } from "antd";
import "./CrrRadioStyles.scss";
import { useEffect, useMemo, useState } from "react";
import { ANSWERS } from "../../../helpers/constants";
import { FrownOutlined, SmileOutlined } from "@ant-design/icons";

export default function CrrRadio(props) {
  const {
    qnId = "", // to check if the page using the component is pre-assessment
    onChange,
    setValue,
    answer,
    options,
    question,
    form,
    setselectField,
    setVisibleQnIds,
    showSmiley,
    loading,
  } = props;
  const [clickedQn, setClickedQn] = useState();
  const formatResponse = (value) => {
    return { question_id: qnId, opted_answer_id: value };
  };

  useEffect(() => {
    // populating the component with answers
    if (answer)
      form.setFieldsValue({
        [qnId]: answer?.opted_answer_id,
      });
    setVisibleQnIds((prev) => ({
      ...prev,
      [qnId]: answer?.opted_answer_id, // Store id of yes for visibility of linked questions
    }));
  }, [answer]);

  useEffect(() => {
    if (!loading) {
      setClickedQn(null); // hide loader once loading ends
    }
  }, [loading]);

  const smileyOptions = useMemo(
    () =>
      options.map((op) => {
        const selected = form.getFieldValue(qnId) === op.value;

        const showLoader =
          loading &&
          qnId === clickedQn?.questionId &&
          op.value === clickedQn?.answerId;

        return {
          value: op.value,
          label: (
            <div
              className={`response-smiley ${
                selected
                  ? op.name === "No"
                    ? "red-button"
                    : "green-button"
                  : ""
              }`}
            >
              {showLoader ? (
                <Spin />
              ) : (
                <>
                  {op.name === "No" ? (
                    <FrownOutlined className="smiley-icon" />
                  ) : (
                    <SmileOutlined className="smiley-icon" />
                  )}
                  {op.name}
                </>
              )}
            </div>
          ),
        };
      }),
    [form.getFieldValue(qnId), clickedQn, loading]
  );

  return (
    <div
      className={`${
        showSmiley ? "custom-smiley-radio" : ""
      } radio-btn-container`}
    >
      {question || ""}
      <Radio.Group
        tabIndex={0}
        options={
          showSmiley
            ? smileyOptions
            : options.map((op) => {
                return { value: op.value, label: op.name };
              })
        }
        onChange={(e) => {
          const selected = e.target.value;
          form.setFieldsValue({
            [qnId]: selected,
          });
          setClickedQn({ questionId: qnId, answerId: selected });
          setValue(e.target.checked);
          setVisibleQnIds((prev) => ({
            ...prev,
            [qnId]: selected, // Store id of yes for visibility of linked questions
          }));

          onChange && onChange(formatResponse(selected));
        }}
        onFocus={() => setselectField(true)}
        defaultValue={answer?.opted_answer_id}
        optionType={showSmiley ? "button" : "radio"}
      />
    </div>
  );
}
